var React = require('react');

function IconCheck (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M15.648 5.676c-.384.077-.614.537-.537.92.153.614.23 1.228.23 1.841a6.875 6.875 0 0 1-6.903 6.904 6.875 6.875 0 0 1-6.904-6.903 6.875 6.875 0 0 1 6.904-6.904c1.303 0 2.53.384 3.605.997.383.23.843.077 1.073-.23.23-.383.077-.844-.23-1.074C11.506.46 9.972 0 8.438 0A8.413 8.413 0 0 0 0 8.438a8.413 8.413 0 0 0 8.438 8.437 8.413 8.413 0 0 0 8.437-8.438c0-.767-.077-1.534-.307-2.224-.077-.383-.537-.614-.92-.537z","key":0}),React.createElement("path",{"d":"M17.762 1.359a.778.778 0 0 0-1.112 0L8.47 9.38 5.85 6.81a.778.778 0 0 0-1.112 0 .743.743 0 0 0 0 1.09l3.177 3.115a.866.866 0 0 0 .556.234.866.866 0 0 0 .555-.234l8.736-8.567a.743.743 0 0 0 0-1.09z","key":1})]);
}

IconCheck.displayName = "IconCheck";

IconCheck.defaultProps = {"width":"18","height":"17","viewBox":"0 0 18 17"};

module.exports = IconCheck;

IconCheck.default = IconCheck;



//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/iconCheck.svg
// module id = 405
// module chunks = 22